import {
  IMedia, IResponse, IData, IList, ICaseFilesManage,
} from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';
import { MEDIA_TYPES, SORT_TYPE } from '@/types/enums';
import { ITEMS_ON_PAGE } from '@/types/consts';

export default class MediaService {
  public static uploadMediaToCase(caseId: string, payload: any): Promise<IResponse<null>> {
    return ApiService.postAndReturnData(`/cases/${caseId}/media/add`, payload);
  }

  public static addFilesToCase(payload: ICaseFilesManage): Promise<IResponse<IData<IMedia[]>>> {
    return ApiService.postAndReturnData('/cases/files/add', payload);
  }

  public static getMediaByType(
    mediaType: MEDIA_TYPES | MEDIA_TYPES[], page: number, searchTerm: string, buyPass = false,
  ): Promise<IResponse<IData<IList<IMedia>>>> {
    const payload = {
      filters: [{ field: 'DISTINCT_BY_CONTENT', value: true }],
      paging: { page, itemsOnPage: ITEMS_ON_PAGE, buyPass },
      sort: [{ field: 'UPDATED', order: SORT_TYPE.DESC }],
      searchTerm,
    } as any;
    if (Array.isArray(mediaType)) {
      payload.groupFilters = [{ field: 'TYPE', value: mediaType }];
    } else {
      payload.filters.push({ field: 'TYPE', value: mediaType });
    }
    return ApiService.postAndReturnData('/files', payload);
  }

  public static getDesktopMediaByType(
    mediaType: MEDIA_TYPES | MEDIA_TYPES[], page: number, searchTerm: string, buyPass = false,
  ): Promise<IResponse<IData<IList<IMedia>>>> {
    const payload = {
      filters: [{ field: 'DISTINCT_BY_CONTENT', value: true }],
      paging: { page, itemsOnPage: 100, buyPass },
      sort: [{ field: 'UPDATED', order: SORT_TYPE.DESC }],
      searchTerm,
    } as any;
    if (Array.isArray(mediaType)) {
      payload.groupFilters = [{ field: 'TYPE', value: mediaType }];
    } else {
      payload.filters.push({ field: 'TYPE', value: mediaType });
    }
    return ApiService.postAndReturnData('/files', payload);
  }

  public static getLowerQualityPhotoById(photoId: string, size = 100): Promise<IResponse> {
    return ApiService.getAndReturnData(`${process.env.VUE_APP_MEDIA_URL}/file/${photoId}/${size}`);
  }

  public static defaultMediaUpload(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return ApiService.postAndReturnData('files/upload', formData);
  }

  public static deleteMedia(id: string): Promise<IResponse> {
    return ApiService.postAndReturnData('files/delete/', { id });
  }

  public static deleteMediaFromCase(item: ICaseFilesManage): Promise<IResponse> {
    return ApiService.postAndReturnData('cases/files/remove', item);
  }

  public static getPublicCaseByUrl(publicUrl: string): Promise<any> {
    return ApiService.getAndReturnData(`${process.env.VUE_APP_MEDIA_URL}/public/case/${publicUrl}`);
  }

  public static deleteAllFiles(ids: string[]): Promise<IResponse> {
    return ApiService.postAndReturnData('files/delete/bunch', { ids });
  }

  public static getFileInfo(fileId: string): Promise<IResponse<IData<IMedia>>> {
    return ApiService.getAndReturnData(`files/get/${fileId}`);
  }
}
